import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { ExternalLinkIcon } from "@gemini/icons";
import { Link } from "@gemini/ui";
export const LocationLink = ({ title, link }) => {
    return (_jsx(Box, { as: "div", display: "flex", textAlign: "left", padding: 0, width: "100%", children: _jsx(Link, { href: link, 
            // @ts-ignore
            justifyContent: "space-between", width: "100%", unsafe_style: { fontSize: "0.875rem" }, iconPosition: "end", icon: () => _jsx(ExternalLinkIcon, { size: "sizing.24" }), children: title }) }));
};
